export const VideoIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#F18536" />
    <path d="M15 31V9L31.5 20L15 31Z" stroke="white" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);
